import { getData, postData, convertToUTCDate } from './api-base.service'
import { formatTimeFromInt60 } from '../config/mUtils'

export const getAllTerms = () => {
    return getData('/TermManage/GetAllTerms');
}

export const getAllTermsByUniversityGroupNumber = (groupNumber) => {
    return getData('/TermManage/GetAllTermsByUniversityGroupNumber', { groupNumber : groupNumber });
}

export const saveTerm = (form) => {
    if (form.Id == null) {
        form.Id = 0;
    }

    form.StartDate = convertToUTCDate(form.StartDate);
    form.EndDate = convertToUTCDate(form.EndDate);
    form.PreRecruiteDate = convertToUTCDate(form.PreRecruiteDate);
    return postData('/TermManage/SaveTerm', form);
}

export const getWeekListByCourseId = (courseId, isNextTerm, getFullWeeks) => {
    if (typeof courseId == "undefined"){
        courseId = null;
    }
    if (typeof isNextTerm == undefined){
        isNextTerm = false;
    }
    if (typeof getFullWeeks == undefined){
        getFullWeeks = false;
    }
    return getData('/TermManage/GetWeekListByCourseId', { courseId: courseId, isNextTerm: isNextTerm, getFullWeeks: getFullWeeks });
}

export const getWeekList = (termId, isNextTerm, getFullWeeks) => {
    if (typeof termId == "undefined"){
        termId = null;
    }
    if (typeof isNextTerm == undefined){
        isNextTerm = false;
    }
    if (typeof getFullWeeks == undefined){
        getFullWeeks = false;
    }
    return getData('/TermManage/GetWeekList', { termId: termId, isNextTerm: isNextTerm, getFullWeeks: getFullWeeks });
}

export const getTrainingTerms = (categoryId) => {
    let data = {
        categoryId: categoryId
    }
    return getData('/TermManage/TrainingTerms', data);
}

export const getTrainingCategoryCourses = (categoryId) => {
    let data = {
        categoryId: categoryId
    }
    return getData('/TermManage/TrainingCategoryCourses', data);
}

export const saveTrainingTerm = (form)=>{
    if (form.Id == null) {
        form.Id = 0;
    }
    form.StartDate = convertToUTCDate(form.StartDate);
    form.EndDate = convertToUTCDate(form.EndDate);  
    let data = $.extend({}, form);
    data.TrainingCourseSchedules = []; 
    form.TrainingCourseSchedules.forEach(element => {
        let item = $.extend({}, element); 
        item.TrainingCourseScheduleDetails.forEach(el=>{
            let dayofweek = el.DayOfWeek;
            if (dayofweek == "7") {
                el.DayOfWeek = '0';
            }
            el.StartTimeText = el.StartTimeInt? formatTimeFromInt60(el.StartTimeInt):null;
            el.EndTimeText = el.EndTimeInt?formatTimeFromInt60(el.EndTimeInt):null;
        }); 
        data.TrainingCourseSchedules.push(item);
    }); 
    return postData('/TermManage/SaveTrainingTerm', data);
}

export const checkTrainingTermSetting = (categoryId)=>{
    let data = {categoryId:categoryId};
    return getData('/TermManage/CheckTrainingTermSetting', data);
}


// WEBPACK FOOTER //
// ./src/service/termManage.service.js